"use client";
import React, { useEffect, useRef } from "react";
import certificates from "../data/certificates.json";
import { useTranslation } from "react-i18next";

function Certificates() {
  const sectionRef = useRef(null);
  useEffect(() => {
    if (window.location.hash === "#contact") {
      sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
    const { t } = useTranslation("translation");

  return (
    <div>
      <h1 className="text-2xl font-bold mb-2 text-[var(--color-main)]">{t("header.certificates")} </h1>
    <div
      ref={sectionRef}
      id="certificates"
      className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6 px-6 py-10 place-items-center"
    >
      {certificates.map((certificate) => (
        // <AnimatedItem key={certificate.id}>
        <div
          key={certificate.id}
          className="  w-[200px] md:size-fit bg-[--color-background] border border-[--color-secondary] rounded-xl overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-2 transition-transform duration-300"
        >
          <img
            src={certificate.img}
            alt={`Certificate ${certificate.id}`}
            width={400} // or whatever fixed or max width you want
            height={240} // adjust as needed
            className="w-full md:h-60 h-40 object-cover hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />
        </div>
        // </AnimatedItem>
      ))}
    </div>
    </div>
  );
}

export default Certificates;
